import type { ILogger } from "@/application/ports/ILogger";
import { getLogger } from "@/infrastructure/di/services";

export function useLogger(): ILogger {
  return getLogger();
}
